import React from 'react';
import { Link } from 'react-router-dom';
import { LuMoveRight } from 'react-icons/lu';
import frame from '../../../../assets/frame.png';
import {
  getNewsPreviewText,
  getSortedNewsData,
} from '../../../../data/newsData';

const AllNews = ({ setChosenNews }) => {
  const sortedNews = getSortedNewsData().sort(
    (firstItem, secondItem) => secondItem.id - firstItem.id,
  );

  return (
    <div className="w-full px-6 md:px-12 pb:6 lg:px-32 lg:pb-12 pt-6">
      <div
        className="bg-cover bg-center flex flex-col lg:flex-row items-center justify-between font-rubik max-h-[250px] lg:max-h-[150px] w-full px-12 py-6 rounded-2xl"
        style={{ backgroundImage: `url(${frame})` }}
      >
        <div className="flex flex-col gap-1">
          <h1 className="text-secondary font-bold text-2xl lg:text-4xl font-quicksand">
            Latest News
          </h1>
        </div>
        <p className=" w-full text-center lg:text-start lg:w-[40%]  text-white font-rubik text-base lg:text-lg">
          Discover our Latest News and Updates from our Organisation
        </p>
      </div>

      <div className="flex items-center justify-between my-8">
        <h1 className="font-quicksand font-bold text-2xl text-primary">
          LATEST NEWS AND UPDATES
        </h1>
      </div>
      <div className="flex flex-wrap gap-4 justify-start">
        {sortedNews?.map((news) => {
          const previewText = getNewsPreviewText(news);
          return (
            <div
              className="p-6 flex flex-col bg-darkGrey max-w-[400px] rounded-lg"
              key={news.id}
            >
              <div className="mb-2 rounded-lg overflow-hidden">
                <img src={news.image} className="w-full max-h-[195px]" alt="" />
              </div>
              <div className="flex items-center gap-4 mt-2">
                <p className="font-nunito font-bold text-secondary">NEWS</p>
                <p className="font-nunito">{news.date}</p>
              </div>
              <h4 className="font-bold text-xl my-2">
                {news.title.length > 40
                  ? news.title.slice(0, 40) + '...'
                  : news.title}
              </h4>

              <p className="text-[#6B6E71]">
                {previewText.length > 100
                  ? previewText.slice(0, 100) + '...'
                  : previewText}
              </p>

              <Link to={'/news/single'} className="w-fit mt-4">
                <div
                  className="flex gap-2 items-center w-fit cursor-pointer"
                  onClick={() => {
                    setChosenNews(news.id);
                  }}
                >
                  <p className="text-secondary font-rubik">Read more</p>
                  <LuMoveRight size={20} color="#FDB935" />
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AllNews;
